export const MODAL_CLOSE_TIMEOUT = 2000;
export const ERROR_TIME = 2000;
export const ERROR_ANIMATION_TIME = 500;

export const BOOLEAN_SELECT_OPTIONS = [
  {label: 'Da', value: true},
  {label: 'Nu', value: false}
];

